<!--在查询无列表数据 展示的方式-->
<template>
  <div class="member-none">
    <img src="@/assets/image/brandbg.png" alt="" class="member-none-img">
        <p class="member-none-text">{{imgtext}}</p>
    </div>  
</template>
<script>
export default {
  props: {
    imgtext: {
      type: String,
      default: "巧妇难为无米之炊，督促设计师尽快添加模版！",
    }
  }
};
</script>

<style lang="scss" scoped>
// 团队中心的404页面——全部为空---------------------------------------
.member-none {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
       //height: calc(100% - 111px);
     .member-none-text {
         font-size: 20px;
         font-family: PingFangSC-Medium, PingFang SC;
         font-weight: 500;
         color: rgba(60, 60, 67, 1);
         line-height: 28px;
         margin: 0 auto;
         transform: translateX(-100px);
         width: 460px;
         height: 28px;
         text-align: center;
     }

     .member-none-img {
         display: block;
         height: 251px;
         width: 300px;
         margin: -40px auto 40px;
         transform: translateX(-100px);
     }


}
</style>